import React from "react";
import styles from "./sponsors.css";
import { SponsorsConfig } from "./SponsorsConf";
import { FormattedMessage } from "react-intl";

export const Sponsors = () => {
  return (
    <div className={styles.container} id="sponsors">
      <h2 className="headerTitle">
        <FormattedMessage id="Sponsors.title" defaultMessage="Our sponsors" />
      </h2>

      <div style={{ backgroundColor: "#cfcece", margin: 20 }}>
        <div className="description" style={{ paddingLeft: 20, paddingTop: 10 }}>
          <p style={{ textAlign: "left" }}>
            La empresa OPSEEKER TECH SL. es beneficiaria del Programa de Fundación “la Caixa” Empleo Joven de ayudas
            para el fomento de la contratación de personas jóvenes.
          </p>
          <p>
            Estas ayudas están cofinanciadas por el Programa Operativo de Empleo Juvenil / Iniciativa de Empleo Juvenil
            – Fondo Social Europeo y por la Fundación Bancaria “la Caixa”.
          </p>
        </div>
        <div className="description" style={{ margin: 0, textAlign: "right" }}>
          <img src={`${process.env.REACT_APP_MEDIA_CONTENT}la-caixa.png`} />
        </div>
      </div>

      <div style={{ backgroundColor: "#cfcece", margin: 20 }}>
        <div className="description" style={{ paddingLeft: 20, paddingTop: 10 }}>
          <p style={{ textAlign: "left" }}>Iniciativa de Emprego de Base Tecnolóxica</p>
        </div>
        <div className="description" style={{ margin: 0, textAlign: "right" }}>
          <img src={`${process.env.REACT_APP_MEDIA_CONTENT}IEBT.jpg`} height="354" />
        </div>
      </div>

      <div style={{ backgroundColor: "#cfcece", margin: 20 }}>
        <div className="description" style={{ paddingLeft: 20, paddingTop: 10 }}>
          <p style={{ textAlign: "left" }}>
            Axudas do Igape Galicia Rural Emprende Operación cofinanciada pola Unión Europea Programa de Desenvolvemento
            Rural de Galicia 2014-2020.
          </p>

          <p>
            Esta empresa foi beneficiaria dunha axuda do programa do Igape de creación de empresas para actividades non
            agrícolas en zonas rurais.
          </p>
          <p>
            O obxectivo principal destas axudas é contríbuir a diversificación económica, crecemento do emprego,
            sustentabilidade do medio rural e equilibrio territorial, tanto en termos económicos como sociais. O
            resultado que se pretende é a creación e o desenvolvemento de pequenas empresas para actividades non
            agrícolas en zonas rurais e a creación de emprego.
          </p>
          <p>
            Desenvolvmente de Ava. Unha rede de decisión dinámica que guía o usuario cara mellores hábitos financieiros.
          </p>
        </div>
        <div className="description" style={{ margin: 0, textAlign: "right" }}>
          <a
            href="https://ec.europa.eu/regional_policy/es/policy/what/glossary/e/european-agricultural-fund-for-rural-development"
            target="_blank"
          >
            <img src={`${process.env.REACT_APP_MEDIA_CONTENT}rural-emprende.png`} height="364" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Sponsors;



// WEBPACK FOOTER //
// ./src/containers/sponsors/Sponsors.js